import { Accordion, AccordionDetails, AccordionSummary, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, IconButton, MenuItem, Modal, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import constants from '../../constant.js';
import mapPin from '../../assets/icons/LocationPin.svg';
import RadiusFrame from '../../assets/images/RadiusFrame.svg';
import binButton from '../../assets/images/binButton.svg';
import { Label } from "flowbite-react";
import { DirectionsRenderer, GoogleMap, InfoWindow, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
import AddIcon from "@mui/icons-material/Add";
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import routeMarker from '../../assets/images/routeMarker.svg';
// import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const ShuttleRoutes = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [geofence, setGeofence] = useState(cities[0].geofence[0]);
    const [geocenter, setGeocenter] = useState({});
    const serverUrl = config.serverUrl;
    const [shuttleRoutesData, setShuttleRoutesData] = useState([]);
    const operationsUrl = config.operationsUrl;
    const [selectedStops, setSelectedStops] = useState([]);
    const [city, setCity] = useState(cities[0]);
    const [shuttleStopsData, setShuttleStopsData] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedStop, setSelectedStop] = useState('');
    const [routeName, setRouteName] = useState('');
    const [showFareModal, setShowFareModal] = useState(false);
    const [showDriverFareModal, setShowDriverFareModal] = useState(false);
    const [stops, setStops] = useState([]);
    const [shuttleFareData, setShuttleFareData] = useState([]);
    const [fareId, setFareId] = useState('');
    const [driverFareId, setDriverFareId] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const navigate = useNavigate();
    const [selectedGridData, setSelectedGridData] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState(null);
    // const [directions, setDirections] = useState(null);
    const [viewData, setViewData] = useState([]);
    const [isFarePerRoute, setIsFarePerRoute] = useState(false);
    const [customerFare, setCustomerFare] = useState('');
    const [driverFare, setDriverFare] = useState('');
    const [openEditFare, setOpenEditFare] = useState(false);
    const [routeId, setRouteId] = useState('');
    const [openSelectPassModal, setOpenSelectPassModal] = useState(false);
    const [shuttlePassData, setShuttlePassData] = useState([]);
    const [passIds, setPassIds] = useState([]);
    const [expandPass, setExpandPass] = useState(false);
    const [shuttleRoutePassesData, setShuttleRoutePassesData] = useState([]);
    const [passRoundRouteMap, setPassRoundRouteMap] = useState([]);
    const [selectedRouteId,setSelectedRouteId] = useState("");

    useEffect(() => {
        if (geofence) {
            const geocenter = {
                lat: geofence.reduce((sum, point) => sum + point.x, 0) / geofence.length,
                lng: geofence.reduce((sum, point) => sum + point.y, 0) / geofence.length,
            };
            setGeocenter(geocenter);
        }
    }, [geofence,cityFilter]);


    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    const [polylineVisible, setPolylineVisible] = useState(false); // Control when polyline is displayed
    const [boundsUpdated, setBoundsUpdated] = useState(false); // Ensure bounds are updated once

    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: 'calc(100vh - 280px)',
    };
    const containerStyle2 = {
        width: '100%',
        height: '84vh',
    };
    const center = {
        lat: geocenter.lat, lng: geocenter.lng
    };
    const pickupLatLng = {
        lat: 28.644800, lng: 77.216721
    };
    
    const onLoad = React.useCallback((map) => {
        setMap(map); // Store the map instance
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    const fetchShuttleRoutes = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_routes';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setShuttleRoutesData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchShuttleRoutes();
        fetchStopsData();
    }, [cityFilter]);

    const handleGridClick = (data) => {
        if (!data.stops || data.stops.length === 0) {
            console.warn('No stops found for selected grid:', data);
            return;
        }
        setPolylineVisible(false);
        setSelectedGridData(data);
        setTimeout(() => {
            setViewData(data.stops);
            setPolylineVisible(true); // Enable polyline after stops are set
        }, 100); // Ensure stops are set properly
    };


    const handleOpenEdit = (row) => {
        fetchShuttlPassData();
        setFareId(row.fare_id);
        setSelectedRouteId(row.route_id);
        setDriverFareId(row.driver_fare_id);
        setRouteName(row.route_name);
        
        setSelectedStops([]); // Clear first to ensure proper update
        setPolylineVisible(false); // Hide polyline initially
        setBoundsUpdated(false); // Reset bounds update flag
        // setIsFarePerRoute(row.is_fare_per_route);
        setDriverFare(row.driver_fare);
        setCustomerFare(row.customer_fare);
        
        setTimeout(() => {
            // setSelectedStops(row.stops); // Update stops
            setViewData(row.stops);
            setPolylineVisible(true); // Enable polyline after stops are set
        }, 100); // Ensure stops are set properly
        setExpandedIndex(false);
    
        setTimeout(() => {
            setOpenEditModal(true);
        }, 200);
        if(row.driver_fare_id==null || row.driver_fare_id==0){
            setIsFarePerRoute(true);
        }
        else{
            setIsFarePerRoute(false);
        }
        let passIdArray=[];
        row.passes.map((item) => {
            passIdArray.push(item.pass_id);
        })
        setPassIds(passIdArray);

        if (row.passes?.length) {
            const initialPassRoundRouteMap = row.passes.map(pass => ({
                pass_id: pass.pass_id,
                return_route_id: pass.return_route_id || null
            }));
            setPassRoundRouteMap(initialPassRoundRouteMap);
        } else {
            setPassRoundRouteMap([]);
        }
    };

    useEffect(() => {

        setPolylineVisible(true);
        
        if (map && selectedGridData && Object.keys(selectedGridData).length > 0) {
            
            // Determine if we have stops array or direct coordinates
            const stopsArray = selectedGridData.stops ||
                               (Array.isArray(selectedGridData) ? selectedGridData : [selectedGridData]);
                        
            if (stopsArray.length > 0) {
                const bounds = new window.google.maps.LatLngBounds();
                let hasValidCoordinates = false;
                
                stopsArray.forEach((stop) => {
                    if (stop.latitude && stop.longitude) {
                        hasValidCoordinates = true;
                        bounds.extend({ lat: Number(stop.latitude), lng: Number(stop.longitude) });
                    }
                });
                
                if (hasValidCoordinates) {
                    // Add a slight delay to ensure map is ready
                    setTimeout(() => {
                        map.fitBounds(bounds);
                        // Sometimes we need to adjust zoom if there's only one point
                        if (map.getZoom() > 15) {
                            map.setZoom(15);
                        }
                    }, 100);
                } else {
                    console.log('No valid coordinates found in data');
                }
                
                // Keep polyline visible - DON'T toggle it off and on again
                // This was causing the route to vanish
                // setPolylineVisible(true);
            }
        }
    }, [selectedGridData, map]);
 

    useEffect(() => {
        if (viewData.length > 0 && map) {
    
            const bounds = new window.google.maps.LatLngBounds();
            viewData.forEach((stop) => {
                if (stop.latitude && stop.longitude) {
                    bounds.extend(new window.google.maps.LatLng(Number(stop.latitude), Number(stop.longitude)));
                }
            });
    
            map.fitBounds(bounds); // Ensure all stops are visible
    
            // Force polyline to update
            setPolylineVisible(false);
            setTimeout(() => {
                setPolylineVisible(true);
            }, 50);
        }
    }, [viewData, map]);    

    const handleDeleteFunc = async(data) => {
        const token = localStorage.getItem('token');
    
        const payload = {
            token: token,
            route_id: data.route_id
        };

        try {
            const url = operationsUrl + '/shuttle/delete_route';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchShuttleRoutes();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message);
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const fetchStopsData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_stops';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setShuttleStopsData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const handleOpenFareModal = () => {
        fetchFareData();
        setShowFareModal(true);
    }
    const handleCloseFareModal = () => {
        setShowFareModal(false);
    }

    const handleOpenDriverFareModal = () => {
        fetchFareData();
        setShowDriverFareModal(true);
    }
    const handleCloseDriverFareModal = () => {
        setShowDriverFareModal(false);
    }
    const fetchFareData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_fare_settings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setShuttleFareData(response.data);
                const activeFareData = response.data.filter(item => item.is_active === 1);
                setShuttleFareData(activeFareData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const handleOpenAddModal = () => {
        setRouteName('');
        setFareId('');
        setDriverFareId('');
        setSelectedStops([]);
        setOpenAddModal(true);
        fetchStopsData();
        setViewData([]);
        setPassIds([]);
        setPassRoundRouteMap([]);
    }
    const handleClose = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        setSelectedGridData([]);
    }

    const saveData = async() => {
        const token = localStorage.getItem('token');

        if(customerFare==0 && isFarePerRoute==1){
            setMessage('Customer fare cannot be zero.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        if(routeName==""){
            setMessage('Please enter route name.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if((fareId=="" || fareId==null) && isFarePerRoute==0){
            setMessage('Please select customer fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if((driverFareId=="" || driverFareId==null) && isFarePerRoute==0){
            setMessage('Please select driver fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if(customerFare==="" && isFarePerRoute==1){
            setMessage('Please enter customer fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if(driverFare==="" && isFarePerRoute==1){
            setMessage('Please enter driver fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        // const cleanedStops = viewData
        // .filter(stop => stop.stop_id) // Remove incomplete stops
        //     .map((stop, index) => ({
        //         stop_id: stop.stop_id,
        //         stop_order_id: index + 1, // Order starts from 1
        //         reach_time: index === 0 ? 0 : Number(stop.reach_time), // First stop has time_to_reach = 0
        //         start_distance: index === 0 ? 0 : Number(stop.start_distance), // First stop has distance_from_start = 0
        //         is_minor: index === 0 ? 0 : Number(stop.is_minor),
        //         wait_time: Number(stop.wait_time),
        //     })
        // );

        const cleanedStops = [];

        for (let i = 0; i < viewData.length; i++) {
            const stop = viewData[i];

            if (!stop.stop_id) continue; // skip incomplete stops

            // Validate reach_time for stops after the first one
            if (i !== 0 && (stop.reach_time === "" || isNaN(stop.reach_time))) {
                setMessage(`Please enter reach time for stop ${i + 1}`);
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
                return; // stop the function early if you're inside a submit handler
            }

            if (i !== 0 && (stop.start_distance === "" || isNaN(stop.start_distance))) {
                setMessage(`Please enter start distance for stop ${i + 1}`);
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
                return; // stop the function early if you're inside a submit handler
            }

            // Validate other fields if needed...

            cleanedStops.push({
                stop_id: stop.stop_id,
                stop_order_id: i + 1,
                reach_time: i === 0 ? 0 : Number(stop.reach_time),
                start_distance: i === 0 ? 0 : Number(stop.start_distance),
                is_minor: i === 0 ? 0 : Number(stop.is_minor),
                wait_time: Number(stop.wait_time),
            });
        }

        // Log if any stops were removed
        if (cleanedStops.length !== selectedStops.length) {
            console.warn("Some stops were incomplete and removed:", selectedStops.filter(stop => !stop.stop_id));
        }

        if(cleanedStops.length==0){
            setMessage('Please fill all the mandatory fields.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        // Replace the existing validation with this:
        const hasInvalidReturnRoute = passRoundRouteMap.some(item => {
            const pass = shuttleRoutePassesData.find(p => p.pass_id === item.pass_id);
            return pass && pass.pass_type === 2 && item.return_route_id === null;
        });

        if (hasInvalidReturnRoute) {
            setMessage('Please select a return route for the selected round trip pass(es).');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        const payload = {
            token: token,
            stops: cleanedStops,
            route_name: routeName,
            // fare_id: fareId,
            // driver_fare_id : driverFareId,
            city_id: cityFilter
        };
        if(passIds.length>0){
            // payload.pass_ids = passIds;
            payload.passes = passRoundRouteMap;
        }

        if(fareId!=="" && !isFarePerRoute){
            payload.fare_id = fareId;
            payload.customer_fare = 0;
        }

        if(driverFareId!=="" && !isFarePerRoute){
            payload.driver_fare_id = driverFareId;
            payload.driver_fare = 0;
        }

        if(customerFare!="" && isFarePerRoute){
            payload.customer_fare = customerFare;
            payload.fare_id =0;
        }

        if(driverFare!=="" && isFarePerRoute){
            payload.driver_fare = driverFare;
            payload.driver_fare_id = 0;
        }
        if(Number(customerFare) < Number(driverFare) && isFarePerRoute){
            setMessage('Customer Fare cannot be less than the driver fare.')
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        try {
            const url = operationsUrl + '/shuttle/add_update_route';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
                setOpenAddModal(false);
                setOpenEditModal(false);
                fetchShuttleRoutes();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    // const handleStopChange = (e) =>{
    //     const stop =  shuttleStopsData.find((stopObj) => stopObj.stop_id === e)
    //     setSelectedStop(e);
    // }

    // Handles adding a new stop
    const handleAddStop = () => {
        setViewData((prevStops) => {
            if(prevStops.length==1 && prevStops[prevStops.length - 1]?.stop_id==""){
                setMessage("Please enter mandatory details for the previous stop before adding a new one.");
                    showSnackbar(true);
                    setTimeout(() => {
                        showSnackbar(false);
                    }, 2000);
                    return prevStops;
            }
            // Validate last stop before adding a new one
            if (prevStops.length > 0) {
                const lastStop = prevStops[prevStops.length - 1];
    
                if (
                    (!lastStop.stop_id ||
                    lastStop.reach_time === "" ||
                    lastStop.start_distance === "") && prevStops.length!=1
                ) {
                    setMessage("Please enter mandatory details for the previous stop before adding a new one.");
                    showSnackbar(true);
                    setTimeout(() => {
                        showSnackbar(false);
                    }, 2000);
                    return prevStops; // Don't add the new stop
                }
            }
    
            const isFirstStop = prevStops.length === 0;
            const newStop = {
                id: prevStops.length + 1,
                stop_id: "",
                is_minor: "0",
                wait_time: "",
                reach_time: isFirstStop ? "0" : "",
                start_distance: isFirstStop ? "0" : "",
            };
    
            const updatedStops = [...prevStops, newStop];
            setExpandedIndex(updatedStops.length - 1);
            return updatedStops;
        });
    };

    // Handles removing a stop
    const handleRemoveStop = (index) => {
        setViewData((prevStops) => prevStops.filter((_, i) => i !== index));
    };
    
    const handleStopChange = (index, field, value) => {
        setViewData((prevData) => {
            // Check if stop_id is already entered (excluding current index)
            if (field === "stop_id") {
                const isDuplicate = prevData.some((stop, i) => stop.stop_id === value && i !== index);
                if (isDuplicate) {
                    setMessage("This stop is already entered.");
                    showSnackbar(true);
                    setTimeout(() => {
                        showSnackbar(false);
                    }, 2000);
                    return prevData; // Don't update if duplicate
                }
    
                const selectedStop = shuttleStopsData.find(s => s.stop_id === value);
                if (selectedStop) {
                    return prevData.map((stop, i) =>
                        i === index
                            ? {
                                  ...stop,
                                  stop_id: selectedStop.stop_id,
                                  name: selectedStop.name,
                                  address: selectedStop.address,
                                  latitude: selectedStop.latitude,
                                  longitude: selectedStop.longitude,
                              }
                            : stop
                    );
                }
            } else {
                return prevData.map((stop, i) =>
                    i === index ? { ...stop, [field]: value } : stop
                );
            }
    
            return prevData;
        });
    };
    

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setGeofence(city.geofence[0]);
    }

    const selectFare = (fareId) =>{
        setFareId(fareId);

        setMessage(`Fare ${fareId} selected`);
        setSnackbarOpen(true);
        setTimeout(() => {
            setSnackbarOpen(false);
        }, 2000);
        handleCloseFareModal();
    }

    const selectDriverFare = (driverFareId) =>{
        setDriverFareId(driverFareId);

        setMessage(`Fare ${driverFareId} selected`);
        setSnackbarOpen(true);
        setTimeout(() => {
            setSnackbarOpen(false);
        }, 2000);
        handleCloseDriverFareModal();
    }

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    
    const handleOpenEditFare = (data) => {
        fetchShuttlPassData();
        setRouteId(data.route_id);
        setOpenEditFare(true);
        setDriverFareId(data.driver_fare_id);
        setFareId(data.fare_id);
        setCustomerFare(data.customer_fare);
        setDriverFare(data.driver_fare);
        if(data.driver_fare_id==null || data.driver_fare_id==0){
            setIsFarePerRoute(true);
        }
        else{
            setIsFarePerRoute(false);
        }
        let passIdArray=[];
        data.passes.map((item) => {
            passIdArray.push(item.pass_id);
        })
        setPassIds(passIdArray);
        if (data.passes?.length) {
            const initialPassRoundRouteMap = data.passes.map(pass => ({
                pass_id: pass.pass_id,
                return_route_id: pass.return_route_id || null
            }));
            setPassRoundRouteMap(initialPassRoundRouteMap);
        } else {
            setPassRoundRouteMap([]);
        }
    }

    const handleCloseEditFare= () => {
        setOpenEditFare(false);
    }

    const saveEditedFare = async() => {
        const token = localStorage.getItem('token');
        if(customerFare==0 && isFarePerRoute==1){
            setMessage('Customer fare cannot be zero.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        if((fareId=="" || fareId==null) && isFarePerRoute==0){
            setMessage('Please select customer fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if((driverFareId=="" || driverFareId==null) && isFarePerRoute==0){
            setMessage('Please select driver fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if(customerFare==="" && isFarePerRoute==1){
            setMessage('Please enter customer fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        else if(driverFare==="" && isFarePerRoute==1){
            setMessage('Please enter driver fare.');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }
        // Replace the existing validation with this:
        const hasInvalidReturnRoute = passRoundRouteMap.some(item => {
            const pass = shuttleRoutePassesData.find(p => p.pass_id === item.pass_id);
            return pass && pass.pass_type === 2 && item.return_route_id === null;
        });

        if (hasInvalidReturnRoute) {
            setMessage('Please select a return route for the selected round trip pass(es).');
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        const payload = {
            token: token,
            route_id: routeId
        };

        if(fareId!=="" && !isFarePerRoute){
            payload.fare_id = fareId;
            payload.customer_fare = 0;
        }

        if(driverFareId!=="" && !isFarePerRoute){
            payload.driver_fare_id = driverFareId;
            payload.driver_fare = 0;
        }

        if(customerFare!="" && isFarePerRoute){
            payload.customer_fare = customerFare;
            payload.fare_id = 0;
        }

        if(driverFare!=="" && isFarePerRoute){
            payload.driver_fare = driverFare;
            payload.driver_fare_id = 0;
        }
        if (passIds.length > 0) {
            payload.passes = passRoundRouteMap
        } else{
            payload.passes = [];
        }

        if(Number(customerFare) < Number(driverFare) && isFarePerRoute){
            setMessage('Customer Fare cannot be less than the driver fare.')
            showSnackbar(true);
            setTimeout(() => {
                showSnackbar(false);
            }, 2000);
            return;
        }

        try {
            const url = operationsUrl + '/shuttle/edit_route_fare';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
                setOpenEditFare(false);
                fetchShuttleRoutes();
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
                setTimeout(() => {
                    showSnackbar(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleOpenSelectPassModal = () => {
        setOpenSelectPassModal(true);
        fetchShuttlPassData();
    };
    const handleCloseSelectPassModal = () => {
        setOpenSelectPassModal(false);
    };

    const fetchShuttlPassData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_pass';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const activePass = response.data.filter(item=> item.status == 1)
                setShuttlePassData(activePass);
                setShuttleRoutePassesData(activePass);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const selectPass = (passId) => {
        setPassIds(prevPassIds => {
            const currentPassIds = Array.isArray(prevPassIds) ? prevPassIds : [];
            const isAdding = !currentPassIds.includes(passId);
            
            // Update the passRoundRouteMap based on whether we're adding or removing the pass
            setPassRoundRouteMap(prev => {
                if (isAdding) {
                    // Add new entry with null return_route_id if it doesn't exist
                    if (!prev.some(item => item.pass_id === Number(passId))) {
                        return [
                            ...prev,
                            { pass_id: Number(passId), return_route_id: null }
                        ];
                    }
                    return prev;
                } else {
                    // Remove the pass entry
                    return prev.filter(item => item.pass_id !== Number(passId));
                }
            });

            // Return the updated pass IDs
            return isAdding 
                ? [...currentPassIds, passId]
                : currentPassIds.filter(id => id !== passId);
        });
    };

    const togglePassSection = (passId) => {
        setExpandPass(prev => ({
            ...prev,
            [passId]: !prev[passId]
        }));
    };

    const handlePassIdRoundRouteMapping = (returnRouteId, passId) => {
        setPassRoundRouteMap(prev => {
            const existingIndex = prev.findIndex(item => item.pass_id === Number(passId));
            
            if (existingIndex >= 0) {
                // Update existing entry
                const newMap = [...prev];
                newMap[existingIndex] = { 
                    ...newMap[existingIndex],
                    return_route_id: returnRouteId ? Number(returnRouteId) : null 
                };
                return newMap;
            }
            
            // If pass not found, add a new entry (shouldn't happen in normal flow)
            return [
                ...prev,
                { 
                    pass_id: Number(passId), 
                    return_route_id: returnRouteId ? Number(returnRouteId) : null 
                }
            ];
        });
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Routes Management</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Route
                    </Button>
                </Grid2>
            </Grid2>

            {shuttleRoutesData.length>1 && (
                <Grid2 sx={{marginTop:'1%'}}><Typography>{shuttleRoutesData.length} Results Found</Typography></Grid2>
            )}
            {shuttleRoutesData.length==0 && (
                <Grid2 sx={{marginTop:'1%'}}><Typography>No Routes Found</Typography></Grid2>
            )}

            <Grid2 item container size={12} spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item size={4} sx={{ overflowY:'auto', maxHeight:'calc(100vh - 270px)'}}>
                    {(shuttleRoutesData).map((data) => {
                        const type = constants.CustomZoneTypeConst[data.type] || null;
                        return(
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:'12px', padding:'4px', marginBottom:'4%', cursor:'pointer'}}
                                key={data.zone_id} onClick={() => handleGridClick(data)}
                                >
                                <Grid2 item container spacing={1.6} sx={{padding:'12px', paddingBottom:'4px'}}>
                                    {/* <Typography>{data.name}</Typography> */}
                                    <Typography sx={{color:'#83888E', fontSize:'18px'}}>Route | </Typography>
                                    <Typography sx={{fontSize:'18px', color:'#0065FF'}}>ID: {data.route_id}</Typography>
                                </Grid2>

                                <Grid2 item sx={{border:'1px solid #D1D5DB', backgroundColor: '#F9F9F9', padding: '6px 12px', borderRadius:'10px', margin:'8px 16px'}}>
                                    <Typography sx={{textAlign:'center', color:'#4E545D'}}>{data.route_name}</Typography>
                                </Grid2>

                                <Grid2 sx={{ padding:'8px', margin:'6px', borderRadius:'4px'}}>
                                    
                                    <Grid2 item sx={{display:'flex'}}>
                                        <Typography>Number of Stops</Typography>
                                        <Grid2 sx={{marginLeft:'auto', backgroundColor:'#2A313C', padding:'5px 25px', borderRadius:'6px'}}>
                                            <Typography sx={{color:'#ffffff'}}>{data.no_of_stops}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    {!!(data.fare_id && data.fare_id!=0 && data.fare_id!=0) && 
                                        <Grid2 item sx={{display:'flex', marginTop:'4%'}}>
                                            <Typography>Customer Fare ID</Typography>
                                            <Grid2 sx={{marginLeft:'auto', backgroundColor:'#F9F9F9', padding:'5px 25px', borderRadius:'6px', border:'1px solid #D1D5DB'}}>
                                                <Typography sx={{color:'#4E545D'}}>{data.fare_id}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    }

                                    {!!(data.driver_fare_id && data.driver_fare_id!=0 && data.driver_fare_id!=0) && 
                                        <Grid2 item sx={{display:'flex', marginTop:'4%'}}>
                                            <Typography>Driver Fare ID</Typography>
                                            <Grid2 sx={{marginLeft:'auto', backgroundColor:'#F9F9F9', padding:'5px 25px', borderRadius:'6px', border:'1px solid #D1D5DB'}}>
                                                <Typography sx={{color:'#4E545D'}}>{data.driver_fare_id}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    }
                                    {!!(data.customer_fare!=null && data.customer_fare!=0) && (
                                        <Grid2 item sx={{display:'flex', marginTop:'4%'}}>
                                            <Typography>Customer Fare Per Route</Typography>
                                            <Grid2 sx={{marginLeft:'auto', backgroundColor:'#F9F9F9', padding:'5px 25px', borderRadius:'6px', border:'1px solid #D1D5DB'}}>
                                                <Typography sx={{color:'#4E545D'}}>{data.customer_fare}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    )}
                                    {!!(data.driver_fare!=null && data.driver_fare!=0) && (                                        <Grid2 item sx={{display:'flex', marginTop:'4%'}}>
                                            <Typography>Driver Fare Per Route</Typography>
                                            <Grid2 sx={{marginLeft:'auto', backgroundColor:'#F9F9F9', padding:'5px 25px', borderRadius:'6px', border:'1px solid #D1D5DB'}}>
                                                <Typography sx={{color:'#4E545D'}}>{data.driver_fare}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    )}
                                    {!expandPass[data.route_id] && 
                                        <Grid2 sx={{display:'flex', alignItems:'center',border:'1px solid #E3E5E8', backgroundColor:'#F7F7F7', borderRadius:'10px', padding:'8px 12px', marginTop:'2%'}}>
                                            <Typography sx={{color:'#4E545D', fontSize:'16px', marginRight:'10px'}}>Total Passes</Typography>
                                            <Grid2 sx={{border:'1px solid #E3E5E8', borderRadius:'50%', padding:'4px 8px'}}>{data.passes?.length}</Grid2>
                                            <Grid2  
                                                onClick={() => data.passes.length > 0 && togglePassSection(data.route_id)}
                                                sx={{marginLeft:'auto'}}>
                                                <KeyboardArrowDownIcon/>
                                            </Grid2>
                                        </Grid2>
                                    }
                                    {expandPass[data.route_id] && (
                                        <Grid2 sx={{border:'1px solid #E3E5E8', backgroundColor:'#fff', borderRadius:'10px', marginTop:'2%'}}>
                                            <Grid2 sx={{display:'flex', alignItems:'center', padding:'8px 12px'}}>
                                                <Typography sx={{color:'#4E545D', fontSize:'16px', marginRight:'10px'}}>Total Passes</Typography>
                                                <Grid2 sx={{border:'1px solid #E3E5E8', borderRadius:'50%', padding:'4px 8px'}}>{data.passes.length}</Grid2>
                                                <Grid2 onClick={() => togglePassSection(data.route_id)} sx={{marginLeft:'auto'}}><KeyboardArrowUpIcon/></Grid2>
                                            </Grid2>
                                            <Box sx={{
                                                borderBottom: '1px solid #E3E5E8',
                                                width: '100%',
                                                my: 1, m:0
                                            }} />
                                            <Grid2 sx={{backgroundColor:'#F7F7F7', padding:'8px 12px', borderRadius:'10px'}}>
                                                {data.passes.map((item, index) => (
                                                    <Grid2 
                                                        key={index} 
                                                        container 
                                                        sx={{
                                                            border: '1px solid #E3E5E8', 
                                                            borderRadius: '12px', 
                                                            padding: '12px 16px', 
                                                            backgroundColor: '#fff', 
                                                            marginTop: index === 0 ? '8px' : '6px',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        {/* Main Content Row */}
                                                        <Grid2 item size={12} sx={{alignItems:'center', display:'flex'}}>
                                                            {/* ID Badge */}
                                                            <Grid2 item>
                                                                <Typography 
                                                                    component="span"
                                                                    sx={{
                                                                        backgroundColor: '#2A313C', 
                                                                        padding: '2px 10px', 
                                                                        borderRadius: '24px', 
                                                                        color: '#fff',
                                                                        fontSize: '13px',
                                                                        fontWeight: 500,
                                                                        display: 'inline-block',
                                                                        width: 'fit-content',
                                                                        lineHeight: '1.5',
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                >
                                                                    ID: {item.pass_id}
                                                                </Typography>
                                                            </Grid2>
                                                            
                                                            {/* Pass Name */}
                                                            <Grid2 item size={7}>
                                                                <Typography 
                                                                    sx={{
                                                                        marginLeft: '12px',
                                                                        color: '#1A1E25'
                                                                    }}
                                                                >
                                                                    {item.pass_name}
                                                                </Typography>
                                                            </Grid2>
                                                            
                                                            {/* Pass Type Badge */}
                                                            <Grid2 item size={2} sx={{marginLeft:"auto"}}>
                                                                <Typography 
                                                                    sx={{
                                                                        backgroundColor: item.pass_type === 1 ? '#E6F7FF' : '#F6FFED',
                                                                        color: item.pass_type === 1 ? '#1890FF' : '#52C41A',
                                                                        padding: '2px 10px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '13px',
                                                                        fontWeight: 500
                                                                    }}
                                                                >
                                                                    {item.pass_type === 1 ? 'One Way' : 'Return'}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>

                                                        {/* Return Route (only for Return type) */}
                                                        {item.pass_type === 2 && (
                                                            <Grid2 item size={12} sx={{ mt: 1 }}>
                                                                <Box 
                                                                    sx={{ 
                                                                        display: 'flex', 
                                                                        alignItems: 'center', 
                                                                        backgroundColor: '#F8F9FA', 
                                                                        padding: '8px 12px', 
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #E9ECEF'
                                                                    }}
                                                                >
                                                                    <Typography 
                                                                        variant="body2" 
                                                                        sx={{ 
                                                                            color: '#495057', 
                                                                            fontSize: '14px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}
                                                                    >
                                                                        Return Route: 
                                                                        <span style={{ 
                                                                            color: '#212529',
                                                                            marginLeft: '6px',
                                                                            fontWeight: 500
                                                                        }}>
                                                                            {item.return_route_id 
                                                                                ? shuttleRoutesData.find(route => route.route_id === item.return_route_id)?.route_name 
                                                                                : 'Not set'}
                                                                        </span>
                                                                    </Typography>
                                                                </Box>
                                                            </Grid2>
                                                        )}
                                                    </Grid2>
                                                ))}
                                            </Grid2>
                                        </Grid2>
                                    )}
                                </Grid2>

                                {/* <hr/> */}
                                

                                <Grid2 item container sx={{marginBottom:'8px', alignItems: 'center'}}>
                                    <Button onClick={() => handleDeleteFunc(data)}>
                                        <img src={binButton} alt="bin" />
                                    </Button>

                                    <Button
                                        variant="contained" 
                                        onClick={() => handleOpenEditFare(data)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', padding:'13px', minWidth:'40px', boxShadow:'none',
                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                        }}>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                            <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                        </svg>
                                    </Button>

                                    <Button variant="contained" sx={{ backgroundColor:'#0DBA78', height:"42px", flexGrow: 1, marginRight:'6px', marginLeft:'10px'}} 
                                    onClick={() => handleOpenEdit(data)}
                                    >
                                        <Typography sx={{color:'#EFFBF7', textTransform:'none'}}>View</Typography>
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )
                    })}
                    
                </Grid2>

                <Grid2 item size={8}>
                    <Grid2 className='mainBox' sx={{padding:'4px'}}>
                        {isLoaded ? (
                            <GoogleMap 
                            key={selectedGridData?.route_id}
                            mapContainerStyle={containerStyle}
                            center={
                                selectedGridData?.stops && selectedGridData.stops.length > 0
                                  ? undefined
                                  : center 
                              }
                                zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                
                                {polylineVisible && selectedGridData?.stops && selectedGridData.stops.map((stop, index) => {
                                    return (
                                        <Marker
                                            key={stop.stop_id}
                                            position={{ lat: Number(stop.latitude), lng: Number(stop.longitude) }}
                                            title={stop.name}
                                            label={{
                                                text: `${index + 1}`,
                                                color: "#0065FF",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                            }}
                                            icon={{
                                                url: routeMarker,
                                                scaledSize: new window.google.maps.Size(40, 40),
                                                labelOrigin: new window.google.maps.Point(20, 14)
                                            }}
                                        />
                                    );
                                })}

                                {polylineVisible && selectedGridData?.stops && selectedGridData.stops.length > 1 && (() => {
                                    return (
                                        <Polyline
                                            path={selectedGridData.stops.map((stop) => ({
                                                lat: Number(stop.latitude),
                                                lng: Number(stop.longitude),
                                            }))}
                                            options={{
                                                strokeColor: "#0065FF",
                                                strokeOpacity: 1.0,
                                                strokeWeight: 3,
                                            }}
                                        />
                                    );
                                })()}
                                    

                            </GoogleMap>
                            
                        ): (<></>)}
                    </Grid2>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '78%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Grid2 item container spacing={2} size={12} sx={{marginLeft:'12px'}}>
                                <Grid2 item size={5} sx={{backgroundColor:'#fff', padding:'12px', borderRadius:'12px', overflowY:'auto',maxHeight: '84vh'}}>
                                    {openAddModal && (
                                        <Typography sx={{color:'#4E545D', fontSize:'24px', fontWeight:500}}>Add New Route</Typography>
                                    )}
                                    
                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Enter Route Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Route Name" fullWidth variant="outlined" type="text" 
                                            value={routeName}
                                            onChange={(e) => setRouteName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Add Stops <span style={{ color: 'red'}}>*</span></Label>

                                        {viewData.map((stop, index) => (
                                            <Accordion key={index} expanded={expandedIndex === index} onChange={() => setExpandedIndex(expandedIndex === index ? null : index)}
                                            style={{ marginBottom: "10px", borderRadius: "8px", background: "#F9F9F9", marginTop:'8px' }}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ display: "flex", alignItems: "center" }}>
                                                    <Typography variant="subtitle1">Stop {index + 1}</Typography>
                                                    <IconButton onClick={() => handleRemoveStop(index)} size="small" style={{ marginLeft: "auto", color: "#D14545" }}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: "#4A4A4A" }}>Stop Name
                                                                <span style={{ color: 'red' }}>*</span></Typography>
                                                            <Select
                                                                value={viewData[index]?.stop_id || ""} // Set selected stop for the specific row
                                                                fullWidth
                                                                displayEmpty
                                                                onChange={(e) => handleStopChange(index, "stop_id", e.target.value)}
                                                                style={{ height: "70px", borderRadius: "8px", backgroundColor: "#FFFFFF" }}
                                                            >
                                                                <MenuItem value="">Select Stop</MenuItem>
                                                                {shuttleStopsData.map((stopOption) => (
                                                                    // <MenuItem sx={{ border: '1px solid #f9f9f9' }} key={stopOption.stop_id} value={stopOption.stop_id}>
                                                                    //     <Typography variant="body1">Name: <b>{stopOption.name}</b></Typography>
                                                                    //     <Typography variant="body2">Address: <b>{stopOption.address}</b></Typography>
                                                                    // </MenuItem>
                                                                    <MenuItem sx={{ border: '1px solid #f9f9f9', display:'block' }} key={stopOption.stop_id} value={stopOption.stop_id}>
                                                                        
                                                                        <Typography variant="body1">
                                                                            <b>{stopOption.name}</b>
                                                                        </Typography>
                                                                        
                                                                        <Typography variant="body2">
                                                                            {stopOption.address}
                                                                        </Typography>
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: "#4A4A4A" }}>
                                                                Start Distance (in Km)
                                                                {index!=0 && <span style={{ color: 'red' }}>*</span>}
                                                            </Typography>
                                                            <TextField
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                placeholder="0"
                                                                disabled={index === 0}
                                                                value={viewData[index]?.start_distance || ''}
                                                                onChange={(e) => {
                                                                    handleStopChange(index, "start_distance", e.target.value);
                                                                }}
                                                                onBlur={(e) => {
                                                                    const value = e.target.value;
                                                                    if (value === '') return;
                                                                    const newDistance = Number(value);
                                                                    if (index > 0) {
                                                                        const previousDistance = Number(viewData[index - 1]?.start_distance);
                                                                        if (newDistance <= previousDistance) {
                                                                            alert(
                                                                                `Start Distance must be greater than the previous stop's start distance (${previousDistance}).`
                                                                            );
                                                                        }
                                                                    }
                                                                }}
                                                                InputProps={{
                                                                    inputProps: { min: 0 },
                                                                    style: { height: "50px", backgroundColor: "#FFFFFF" },
                                                                }}
                                                            />
                                                        </Grid>


                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: "#4A4A4A" }}>Wait Time (in Minutes)</Typography>
                                                            <TextField
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                placeholder="0"
                                                                value={viewData[index]?.wait_time}
                                                                onChange={(e) => handleStopChange(index, "wait_time", e.target.value)}
                                                                InputProps={{ inputProps: { min: 0 }, style: { height: "50px", backgroundColor: "#FFFFFF" } }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: "#4A4A4A" }}>
                                                                Reach Time (in Minutes)
                                                                {index!=0 && <span style={{ color: 'red' }}>*</span>}
                                                            </Typography>
                                                            <TextField
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                placeholder="0"
                                                                disabled={index === 0}
                                                                value={viewData[index]?.reach_time || ''}
                                                                onChange={(e) => {
                                                                // Update state immediately so the user can type freely
                                                                handleStopChange(index, "reach_time", e.target.value);
                                                                }}
                                                                onBlur={(e) => {
                                                                const value = e.target.value;
                                                                if (value === '') return; // Skip validation if the field is empty
                                                                const newTime = Number(value);
                                                                if (index > 0) {
                                                                    // Get the previous stop's reach time
                                                                    const previousTime = Number(viewData[index - 1]?.reach_time);
                                                                    if (newTime <= previousTime) {
                                                                    alert(
                                                                        `Reach Time must be greater than the previous stop's time (${previousTime} minutes).`
                                                                    );
                                                                    // Optionally, you can reset the field to a valid value here
                                                                    }
                                                                }
                                                                }}
                                                                InputProps={{
                                                                inputProps: { min: 0 },
                                                                style: { height: "50px", backgroundColor: "#FFFFFF" },
                                                                }}
                                                            />
                                                        </Grid>


                                                        <Grid item xs={12}>
                                                            <Typography variant="subtitle2" style={{ color: "#4A4A4A" }}>Is Minor</Typography>
                                                            {/* <TextField
                                                                type="number"
                                                                variant="outlined"
                                                                fullWidth
                                                                placeholder="0" disabled={index === 0}
                                                                value={selectedStops[index]?.is_minor}
                                                                // value={stop.timeToReach}
                                                                onChange={(e) => handleStopChange(index, "is_minor", e.target.value)}
                                                                InputProps={{ inputProps: { min: 0 }, style: { height: "50px", backgroundColor: "#FFFFFF" } }}
                                                            /> */}
                                                            <Select sx={{marginTop:'2%'}}
                                                                value={viewData[index]?.is_minor} fullWidth
                                                                disabled={index === 0}
                                                                onChange={(e) => handleStopChange(index, "is_minor", e.target.value)}
                                                                style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                                {/* <MenuItem value="">Status</MenuItem> */}
                                                                <MenuItem value="1">Yes</MenuItem>
                                                                <MenuItem value="0">No</MenuItem>
                                                            </Select>
                                                        </Grid>
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}

                                        
                                        <Grid2 container>
                                            <Button variant="outlined" color="primary" onClick={handleAddStop} startIcon={<AddIcon />}
                                                style={{
                                                    marginTop:"10px", height:"50px", borderRadius:"8px", color:"#0065FF",borderColor:"#0065FF",
                                                    textTransform:"none", display:"flex",alignItems:"center",justifyContent:"center",
                                                }}
                                            >
                                                Add Stop
                                            </Button>
                                        </Grid2>

                                    </Grid2>

                                    <Grid2 item container size={12} sx={{ marginTop:'4%', alignItems:'center'}}>
                                        <Grid2 item size={4}>
                                            <Typography sx={{marginTop:'1%'}}>Fare per Route</Typography>
                                        </Grid2>
                                        <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                        <Grid2 item size={6}>
                                            <Switch checked={isFarePerRoute} 
                                            onChange={(e) => {
                                                setIsFarePerRoute(e.target.checked)
                                            }} 
                                            inputProps={{ 'aria-label': 'controlled' }} />
                                        </Grid2>
                                    </Grid2>

                                    {!isFarePerRoute && (
                                        <>
                                            {/* { openEditModal && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth >View Customer Fare</Button>
                                                </Grid2>
                                            )} */}
                                            { !!(openEditModal && fareId && fareId!=0) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >View Customer Fare</Button>
                                                </Grid2>
                                            )}

                                            {!!(openEditModal && (fareId=='' || fareId==null || fareId==0)) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >Select Customer Fare</Button>
                                                </Grid2>
                                            )}

                                            { !!(openAddModal && fareId) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth >View Customer Fare</Button>
                                                </Grid2>
                                            )}

                                            { !!(openAddModal && (fareId=='' || fareId==0)) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth >Select Customer Fare</Button>
                                                </Grid2>
                                            )}

                                            { !!(openEditModal && driverFareId && driverFareId!=0) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >View Driver Fare</Button>
                                                </Grid2>
                                            )}

                                            { !!(openEditModal && (driverFareId=='' || driverFareId==null || driverFareId==0)) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >Select Driver Fare</Button>
                                                </Grid2>
                                            )}

                                            { !!(openAddModal && driverFareId) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth >View Driver Fare</Button>
                                                </Grid2>
                                            )}

                                            {!!(openAddModal && (driverFareId=='' || driverFareId==0)) && (
                                                <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                                    <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth >Select Driver Fare</Button>
                                                </Grid2>
                                            )}

                                        </>
                                    )}

                                    {isFarePerRoute && (
                                        <>
                                            <Grid2 item container size={12} sx={{ marginTop:'6%', alignItems:'center'}}>
                                                <Grid2 item size={4}>
                                                    <Typography>Customer Fare<span style={{ color: 'red' }}>*</span></Typography>
                                                </Grid2>
                                                <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                <Grid2 item size={6.7}>
                                                    <TextField size="small" fullWidth type="number"
                                                        value={customerFare}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (Number(value) >= 0 || value === "") {
                                                              setCustomerFare(value);
                                                            }
                                                        }}
                                                        sx={{ height:'30px', marginLeft:'4%' }}
                                                    />
                                                </Grid2>
                                            </Grid2>

                                            <Grid2 item container size={12} sx={{ marginTop:'8%', alignItems:'center', marginBottom:'6%'}}>
                                                <Grid2 item size={4}>
                                                    <Typography>Driver Fare<span style={{ color: 'red' }}>*</span></Typography>
                                                </Grid2>
                                                <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                <Grid2 item size={6.7}>
                                                    <TextField size="small" fullWidth type="number"
                                                        value={driverFare}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (Number(value) >= 0 || value === "") {
                                                              setDriverFare(value);
                                                            }
                                                        }}
                                                        // onChange={(e) => setDriverFare(e.target.value)}
                                                        sx={{ height:'30px', marginLeft:'4%' }}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                        </>
                                    )}
                                    <hr style={{border: 'none', borderTop: '1px solid #D1D5DB', marginTop:'16px'}} />

                                    <Grid2 sx={{ marginTop:'16px', display:'flex', alignItems:'center'}}>
                                        <Typography sx={{ fontSize:'16px'}}>Add Passes: </Typography>
                                        <Grid2 sx={{marginLeft:'auto'}}>
                                            <Button variant="contained" onClick={handleOpenSelectPassModal}
                                                sx={{backgroundColor:'#D1D5DB', borderRadius:'10px', padding:'4px 12px', fontSize:'14px', textTransform:'none', boxShadow:'none', color:"#000"}}>
                                                Add Passes
                                            </Button>
                                        </Grid2>
                                    </Grid2>

                                    <Box sx={{ gap: 1, marginTop: 2 }}>
                                        {passIds.length > 0 && 
                                            passIds.map((passId, index) => (
                                                <Grid2 key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'12px', padding:'6px 8px', backgroundColor:'#f7f7f7', marginTop:'8px'}}>
                                                    <Grid2 container sx={{display:'flex', alignItems:'center'}}>
                                                        <Grid2 item sx={{display: 'flex', alignItems: 'center', flexGrow: 1}}>
                                                            <Typography sx={{backgroundColor:'#2A313C', padding:'2px 8px', borderRadius:'24px', color:'#fff', whiteSpace: 'nowrap'}}>
                                                                ID: {passId}
                                                            </Typography>
                                                            <Typography sx={{marginLeft:'12px', whiteSpace: 'nowrap'}}>
                                                                {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_name}
                                                            </Typography>
                                                            <Typography sx={{marginLeft:'12px', color:'#9FA3A7', whiteSpace: 'nowrap'}}>
                                                                {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_type === 1 ? '(One Way)' : '(Return)'}
                                                            </Typography>
                                                        </Grid2>
                                                        <Grid2 item>
                                                            <IconButton 
                                                                size="small" 
                                                                onClick={() => {
                                                                    const updatedPassIds = [...passIds];
                                                                    updatedPassIds.splice(index, 1);
                                                                    setPassIds(updatedPassIds);

                                                                    // Clean up the round route mapping for this pass
                                                                    setPassRoundRouteMap(prev => 
                                                                        prev.filter(item => item.pass_id !== passId)
                                                                    );
                                                                }}
                                                                sx={{ padding: '4px', border:'1px solid #E3E5E8', borderRadius:'50%' }}
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        </Grid2>
                                                    </Grid2>
                                                        
                                                    {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_type === 2 && (
                                                        <Grid2 item container size={12} sx={{ marginTop:'2%', alignItems:'center'}}>
                                                            <Grid2 item size={3}>
                                                                <Typography>Round Route</Typography>
                                                            </Grid2>
                                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                            <Grid2 item size={7}>
                                                                <Select
                                                                    value={passRoundRouteMap.find(item => item.pass_id === passId)?.return_route_id || ''} 
                                                                    fullWidth
                                                                    onChange={(e) => handlePassIdRoundRouteMapping(e.target.value, passId)}
                                                                    style={{ height: '40px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}
                                                                    displayEmpty
                                                                    renderValue={(selected) => {
                                                                        if (!selected) {
                                                                            return <span style={{ color: '#9e9e9e' }}>Select a route</span>;
                                                                        }
                                                                        const route = shuttleRoutesData.find(r => r.route_id === selected);
                                                                        return route ? route.route_name : '';
                                                                    }}
                                                                >
                                                                    {shuttleRoutesData
                                                                    .filter(routeData => routeData.route_id !== selectedRouteId)
                                                                    .map((routeData) => (
                                                                        <MenuItem key={routeData.route_id} value={routeData.route_id}>
                                                                            {routeData.route_name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </Grid2>
                                                        </Grid2>
                                                    )}
                                                </Grid2>
                                            ))
                                        }
                                    </Box>

                                    <Grid2 container item sx={{marginTop:'12%', justifyContent:'center', marginBottom:'4%'}} spacing={4}>
                                        {/* {openAddModal && ( */}
                                            <Grid2 item>
                                                <Button variant="contained" sx={{backgroundColor:'#0065FF', textTransform:'none', width:'120px'}} onClick={saveData}>{openAddModal ? 'Create' : 'Create Route'}</Button>
                                            </Grid2>
                                        {/* )} */}
                                        
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#D14545', textTransform:'none', width:'120px'}} onClick={handleClose}>Cancel</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={7}>

                                    {isLoaded ? (
                                        <GoogleMap mapContainerStyle={containerStyle2} 
                                        center={viewData.length > 0 
                                            ? { lat: Number(viewData[0].latitude), lng: Number(viewData[0].longitude) } 
                                            : center}
                                        zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                            {shuttleStopsData.length > 0 && shuttleStopsData.map((marker) => {
                                                return (
                                                    <Marker
                                                        key={marker.stop_id}
                                                        position={{ lat: Number(marker.latitude), lng: Number(marker.longitude) }}
                                                        title={marker.name} // Tooltip text when hovering over the marker
                                                        icon={{
                                                            url: mapPin,
                                                            scaledSize: new window.google.maps.Size(30, 30)
                                                        }}
                                                    />
                                                );
                                            })}

                                            {polylineVisible && viewData.map((stop, index) => (
                                                <Marker
                                                    key={stop.stop_id}
                                                    position={{ lat: Number(stop.latitude), lng: Number(stop.longitude) }}
                                                    title={stop.name}
                                                    label={{
                                                        text: `${index+1}`, // Display Stop ID
                                                        color: "#0065FF", // White text color
                                                        fontWeight: "bold", // Bold text
                                                        fontSize: "14px", // Adjust text size
                                                    }}
                                                    icon={{
                                                        url: routeMarker,
                                                        scaledSize: new window.google.maps.Size(40, 40),
                                                        labelOrigin: new window.google.maps.Point(20, 14)
                                                    }}
                                                />
                                            ))}

                                            {/* {directions && <DirectionsRenderer directions={directions} />} */}
                                            {polylineVisible && viewData.length > 1 && (
                                                <Polyline
                                                    path={viewData.map((stop) => ({
                                                        lat: Number(stop.latitude),
                                                        lng: Number(stop.longitude),
                                                    }))}
                                                    options={{
                                                        strokeColor: "#0065FF",
                                                        strokeOpacity: 1.0,
                                                        strokeWeight: 3,
                                                    }}
                                                />
                                            )}

                                        </GoogleMap>
                                        
                                    ): (<></>)}
                                </Grid2>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            {/* {showFareModal && ( */}
                <Modal
                    open={showFareModal}
                    onClose={handleCloseFareModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{position:'absolute',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',width: 1000, maxHeight:'60vh', display:'flex',
                        flexDirection:'column',bgcolor: 'background.paper',border: '2px solid #000',boxShadow: 24,p: 4, overflow:'hidden' }}>
                        <TableContainer className="table-container" sx={{maxHeight:'80vh', overflowY: 'auto', }}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare ID</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Type</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare Per Stop</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Base Fare</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare per Km</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {shuttleFareData.map((row) => {

                                        return(
                                            <TableRow key={row.id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.type==1 ? 'Fare Per Km' : "Fare Per Stop"}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', fontWeight:'500' }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_stop}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.base_fare}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_km}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Button onClick={() => selectFare(row.fare_id)}
                                                    sx={{
                                                        backgroundColor: fareId === row.fare_id ? "#0DBA78" : "#f0f0f0",
                                                        color: fareId === row.fare_id ? "white" : "black",
                                                        "&:hover": {
                                                            backgroundColor: fareId === row.fare_id ? "#0CA567" : "#e0e0e0",
                                                        }}}>
                                                    {fareId === row.fare_id ? "Selected" : "Select"}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </Modal>
            {/* )} */}

                <Modal
                    open={showDriverFareModal}
                    onClose={handleCloseDriverFareModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{position:'absolute',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',width: 1000, maxHeight:'60vh', display:'flex',
                        flexDirection:'column',bgcolor: 'background.paper',border: '2px solid #000',boxShadow: 24,p: 4, overflow:'hidden' }}>
                        <TableContainer className="table-container" sx={{maxHeight:'80vh', overflowY: 'auto', }}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare ID</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Type</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare Per Stop</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Base Fare</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare per Km</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {shuttleFareData.map((row) => {

                                        return(
                                            <TableRow key={row.id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.type==1 ? 'Fare Per Km' : "Fare Per Stop"}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', fontWeight:'500' }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_stop}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.base_fare}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.fare_per_km}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Button onClick={() => selectDriverFare(row.fare_id)}
                                                    sx={{
                                                        backgroundColor: driverFareId === row.fare_id ? "#0DBA78" : "#f0f0f0",
                                                        color: driverFareId === row.fare_id ? "white" : "black",
                                                        "&:hover": {
                                                            backgroundColor: driverFareId === row.fare_id ? "#0CA567" : "#e0e0e0",
                                                        }}}>
                                                    {driverFareId === row.fare_id ? "Selected" : "Select"}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </Modal>

                <Dialog
                    open={openEditFare}
                    onClose={() => handleCloseEditFare()}
                    PaperProps={{
                        style: {
                            borderRadius: '12px', width:'500px',
                            padding: '10px'
                        }
                    }}
                >
                    <DialogTitle sx={{fontWeight:'bold'}}>Edit Fare & Passes<hr/></DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                           <Grid2 item container size={12} sx={{ marginTop:'1%', alignItems:'center'}}>
                                <Grid2 item size={4}>
                                    <Typography sx={{marginTop:'1%'}}>Fare per Route</Typography>
                                </Grid2>
                                <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                <Grid2 item size={6}>
                                    <Switch checked={isFarePerRoute} 
                                    onChange={(e) => {
                                        setIsFarePerRoute(e.target.checked)
                                    }} 
                                    inputProps={{ 'aria-label': 'controlled' }} />
                                </Grid2>
                            </Grid2>

                            {!isFarePerRoute && (
                                <>
                                    { !!(fareId && fareId!=0) && (
                                        <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                            <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >View Customer Fare</Button>
                                        </Grid2>
                                    )}

                                    { !!(fareId=='' || fareId==null || fareId==0) && (
                                        <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                            <Button onClick={handleOpenFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >Select Customer Fare</Button>
                                        </Grid2>
                                    )}

                                    { !!(driverFareId && driverFareId!=0) && (
                                        <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                            <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >View Driver Fare</Button>
                                        </Grid2>
                                    )}

                                    { !!(driverFareId=='' || driverFareId==null || driverFareId==0) && (
                                        <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                            <Button onClick={handleOpenDriverFareModal} variant="outlined" color="primary" fullWidth sx={{textTransform:'none'}} >Select Driver Fare</Button>
                                        </Grid2>
                                    )}

                                </>
                            )}

                            {isFarePerRoute && (
                                <>
                                    <Grid2 item container size={12} sx={{ marginTop:'6%', alignItems:'center'}}>
                                        <Grid2 item size={4}>
                                            <Typography>Customer Fare<span style={{ color: 'red' }}>*</span></Typography>
                                        </Grid2>
                                        <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                        <Grid2 item size={6.7}>
                                            <TextField size="small" fullWidth type="number"
                                                value={customerFare}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (Number(value) >= 0 || value === "") {
                                                        setCustomerFare(value);
                                                    }
                                                }}
                                                sx={{ height:'30px', marginLeft:'4%' }}
                                            />
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 item container size={12} sx={{ marginTop:'8%', alignItems:'center', marginBottom:'6%'}}>
                                        <Grid2 item size={4}>
                                            <Typography>Driver Fare<span style={{ color: 'red' }}>*</span></Typography>
                                        </Grid2>
                                        <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                        <Grid2 item size={6.7}>
                                            <TextField size="small" fullWidth type="number"
                                                value={driverFare}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (Number(value) >= 0 || value === "") {
                                                        setDriverFare(value);
                                                    }
                                                }}
                                                // onChange={(e) => setDriverFare(e.target.value)}
                                                sx={{ height:'30px', marginLeft:'4%' }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                </>
                            )}

                            <hr style={{border: 'none', borderTop: '1px solid #D1D5DB', marginTop:'16px'}} />

                            <Grid2 sx={{ marginTop:'16px', display:'flex', alignItems:'center'}}>
                                <Typography sx={{fontWeight:500, fontSize:'16px'}}>Add Passes: </Typography>
                                <Grid2 sx={{marginLeft:'auto'}}>
                                    <Button variant="contained" onClick={handleOpenSelectPassModal}
                                        sx={{backgroundColor:'#D1D5DB', borderRadius:'10px', padding:'4px 12px', fontSize:'14px', textTransform:'none', boxShadow:'none', color:"#000"}}>
                                        Add Passes
                                    </Button>
                                </Grid2>
                            </Grid2>

                            <Box sx={{ gap: 1, marginTop: 2 }}>
                                {passIds.length > 0 && 
                                    passIds.map((passId, index) => (
                                        <Grid2 key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'12px', padding:'6px 8px', backgroundColor:'#f7f7f7', marginTop:'8px'}}>
                                            <Grid2 container sx={{display:'flex', alignItems:'center'}}>
                                                <Grid2 item sx={{display: 'flex', alignItems: 'center', flexGrow: 1}}>
                                                    <Typography sx={{backgroundColor:'#2A313C', padding:'2px 8px', borderRadius:'24px', color:'#fff', whiteSpace: 'nowrap'}}>
                                                        ID: {passId}
                                                    </Typography>
                                                    <Typography sx={{marginLeft:'12px', whiteSpace: 'nowrap'}}>
                                                        {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_name}
                                                    </Typography>
                                                    <Typography sx={{marginLeft:'12px', color:'#9FA3A7', whiteSpace: 'nowrap'}}>
                                                        {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_type === 1 ? '(One Way)' : '(Return)'}
                                                    </Typography>
                                                </Grid2>
                                                <Grid2 item>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => {
                                                            // Remove the pass ID from passIds
                                                            const updatedPassIds = passIds.filter((_, i) => i !== index);
                                                            setPassIds(updatedPassIds);
                                                            // Remove the corresponding entry from passRoundRouteMap
                                                            setPassRoundRouteMap(prev => 
                                                                prev.filter(item => item.pass_id !== passId)
                                                            );
                                                        }}
                                                        sx={{ padding: '4px', border:'1px solid #E3E5E8', borderRadius:'50%' }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Grid2>
                                            </Grid2>
                                                
                                            {shuttleRoutePassesData.find(pass => pass.pass_id === passId)?.pass_type === 2 && (
                                                <Grid2 item container size={12} sx={{ marginTop:'2%', alignItems:'center'}}>
                                                    <Grid2 item size={3}>
                                                        <Typography>Round Route</Typography>
                                                    </Grid2>
                                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                    <Grid2 item size={7}>
                                                        <Select
                                                            value={passRoundRouteMap.find(item => item.pass_id === passId)?.return_route_id || ''} 
                                                            fullWidth
                                                            onChange={(e) => handlePassIdRoundRouteMapping(e.target.value, passId)}
                                                            style={{ height: '40px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}
                                                            displayEmpty
                                                            renderValue={(selected) => {
                                                                if (!selected) {
                                                                    return <span style={{ color: '#9e9e9e' }}>Select a route</span>;
                                                                }
                                                                const route = shuttleRoutesData.find(r => r.route_id === selected);
                                                                return route ? route.route_name : '';
                                                            }}
                                                        >
                                                            {shuttleRoutesData
                                                            .filter(routeData => routeData.route_id !== routeId)
                                                            .map((routeData) => {
                                                                console.log(routeData);
                                                                return (
                                                                    <MenuItem key={routeData.route_id} value={routeData.route_id}>
                                                                        {routeData.route_name}
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Grid2>
                                                </Grid2>
                                            )}
                                        </Grid2>
                                    ))
                                }
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{paddingBottom:'20px', marginTop:'10px', justifyContent:'center'}}>
                        <Button 
                            onClick={() => saveEditedFare()} 
                            sx={{
                                color: '#0065ff', 
                                borderRadius:'8px', 
                                textTransform:'none',
                                border:'1px solid #0065ff',
                                width:'120px',
                                '&:hover': {
                                    backgroundColor: '#0065ff',
                                    color: '#fff',
                                },
                            }}
                        >
                            Save
                        </Button>
                        <Button 
                            onClick={() => {
                                handleCloseEditFare();
                            }}
                            sx={{ 
                                color: '#EF4444', 
                                border: '1px solid #EF4444', 
                                borderRadius:'8px', width:'120px',
                                textTransform:'none',
                                '&:hover': {
                                    backgroundColor: '#EF4444',
                                    color: '#fff',
                                },
                            }}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* shuttle pass */}
                <Modal
                    open={openSelectPassModal}
                    onClose={handleCloseSelectPassModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{position:'absolute',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',width: 1000, maxHeight:'60vh', display:'flex',
                        flexDirection:'column',bgcolor: 'background.paper',border: '2px solid #000',boxShadow: 24,p: 4, overflow:'hidden' }}>
                        <TableContainer className="table-container" sx={{maxHeight:'80vh', overflowY: 'auto', }}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Pass ID</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Pass Name</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Pass Type</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Morning/Evening Rides</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Validity (Days)</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Fare Discount (%)</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Recommended</TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {shuttlePassData.map((row) => {

                                        return(
                                            <TableRow key={row.pass_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_name}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_type==1 ? 'One way' : 'Return'}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                        {row.morning_rides
                                                        ? `${row.morning_rides} / ${row.evening_rides}`
                                                        : row.total_rides}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.validity_days}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.discount_percentage}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: '60px', minWidth: '100px', color: row.status === 1 ? '#FFFFFF' : '#000000', backgroundColor: row.status==1 ? '#0DBA78' : '#E3E5E8', borderRadius:'10px', fontWeight:'500' }}>
                                                        {row.status==1 ? 'Active' : 'Inactive'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_recommended === 1 ? '#0DBA78' : '#D14545', }}>{row.is_recommended==1 ? 'Yes' : 'No'}</Typography></TableCell>
                                                                                        
                                                <TableCell align="center">
                                                    <Button 
                                                        onClick={() => selectPass(row.pass_id)}
                                                        sx={{
                                                            backgroundColor: (passIds || []).includes(row.pass_id) ? "#0DBA78" : "#f0f0f0",
                                                            color: (passIds || []).includes(row.pass_id) ? "white" : "black",
                                                            "&:hover": {
                                                                backgroundColor: (passIds || []).includes(row.pass_id) ? "#0CA567" : "#e0e0e0",
                                                            }
                                                        }}
                                                    >
                                                        {(passIds || []).includes(row.pass_id) ? "Selected" : "Select"}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{
                            flexShrink: 0,
                            pt: 2,
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'center',
                            backgroundColor: 'background.paper'
                        }}>
                            <Button onClick={handleCloseSelectPassModal}
                                variant="contained" color="primary" sx={{textTransform:'none', boxShadow:'none', width:'140px'}}
                            >
                                Done
                            </Button>
                        </Box>
                        
                    </Box>
                </Modal>

            {/* Toast Notification */}
            <Snackbar
                open={snackbar}
                autoHideDuration={2000} // Close after 2 seconds
                onClose={handleCloseSnackbar}
                message={message}
            />

        </div>
    )
}

export default ShuttleRoutes;